import {useContext} from 'react';
import {RootContext} from '../context/root-context';
import {Language} from '../@types/ui.types.ts';

export const useLanguage: () => [Language, (language: Language) => void] = () => {
  const {language, setLanguage} = useContext(RootContext);
  return [language, setLanguage];
};
